import React from 'react';
import Routes from './routes';

import './styles/theme.scss';
import './styles/fade.scss';

function App() {
  return <Routes />;
}

export default App;
